import React from "react";
import { HeroReuse } from "../../components/common/HeroReuse";
import articleImg from "../../assets/blogImage3.png"
import ArticleContent from "../../components/sections/blog/ArticleContent";
import { articleContent3 } from "../../constants/data";

const ArticleThird = ({title, description }) => {
  return (
    <div className="flex flex-col items-center justify-center gap-[2.25rem] sm:gap-16 lg:gap-0">
      <HeroReuse
        Title="The Startup Rollercoaster: Behind the scenes of starting RegTechFlow"
        Description="It all started at the end of 2022 — There was no budget, no pitch deck, no plan. Just a stubborn belief that something better had to exist"
        date="23 Apr 2025"
        imgUrl={articleImg}
        titleClass={'tracking-tight pt-3 md:pt-8'}
      />
      <ArticleContent content={articleContent3} toolsClass="font-bold text-darkGray"/>
      {/* <RequestDemo/> */}
    </div>
  );
};

export default ArticleThird;
